var map = {
	"./Aggressive/jobRolesData.json": [
		6740,
		740
	],
	"./Conservative/jobRolesData.json": [
		3347,
		347
	],
	"./PulseCast/jobRolesData.json": [
		6656,
		656
	],
	"./Realistic/jobRolesData.json": [
		4398,
		398
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3033;
module.exports = webpackAsyncContext;